<div class="container">
    <ul class="chronology p-0">
        <!-- timeline events -->
        <li *ngFor="let event of events; index as i" class="chronology">
            <!-- timeline event icon -->
            <i [className]="getIcon(event)"></i>
            <details [className]="getDirection(event)" [open]="event.open">
                <!-- timeline event title -->
                <summary>
                    <span>{{event.title}} <span *ngIf="event.createdBy && event.createdBy !== 'SYSTEM'">
                            {{'BY' | translate}} {{event.createdBy}}<br /></span>
                    </span>
                    <span title="{{intl.formatDate(intl.parseDate(event.time), 'g')}}">
                        {{intl.formatDate(intl.parseDate(event.time), event.open ? { 'datetime': 'medium'} : 'g') }}
                    </span>
                </summary>
                <!-- timeline event content-->
                <div>
                    <p>{{event.content}}</p>
                </div>
            </details>
        </li>
    </ul>
</div>